import 'vite/modulepreload-polyfill'
import 'react-perfect-scrollbar/dist/css/styles.css'
import 'react-quill-new/dist/quill.snow.css'
import 'nprogress/nprogress.css'
import { HelmetProvider } from '@dr.pogodin/react-helmet'
import { StyledEngineProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import { MapProvider } from 'react-map-gl/maplibre'
// import {
//     createBrowserRouter,
//     RouterProvider
// } from "react-router-dom"
import { Provider as ReduxProvider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import 'regenerator-runtime/runtime'
import 'maplibre-gl/dist/maplibre-gl.css'

// eslint-disable-next-line import/no-extraneous-dependencies
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import App from './App'
import PostHogIdentity from './components/PostHogIdentity'
import RootErrorFallback from './components/RootErrorFallback'
import { BrandingProvider } from './contexts/BrandingContext'
import { AuthProvider } from './features/allauth/context/AllauthAuthContext'
import { initFaro, reportError } from './lib/faro'
import { initPostHog } from './lib/posthog'
import store from './store'

// Initialise browser telemetry before render so early errors are captured.
// No-op unless VITE_FARO_URL is set (Faro stays inert in dev).
initFaro()
// Product analytics. No-op unless VITE_POSTHOG_KEY is set.
initPostHog()

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: 1,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true
        },
        mutations: {
            retry: 0
        }
    }
})
const container = document.getElementById('root')
const root = createRoot(container)
root.render(
    <StrictMode>
        <HelmetProvider>
            <QueryClientProvider client={queryClient}>
                <ReduxProvider store={store}>
                    <StyledEngineProvider injectFirst>
                        <LocalizationProvider
                            dateAdapter={AdapterLuxon}
                            adapterLocale="system"
                        >
                            {/* <SettingsProvider> */}
                            <div>
                                {' '}
                                {/* This div is necessary for the router to work - double page error */}
                                <BrowserRouter>
                                    <ErrorBoundary
                                        FallbackComponent={RootErrorFallback}
                                        onError={(error, info) =>
                                            reportError(error, {
                                                label: 'auth-provider-root',
                                                componentStack:
                                                    info?.componentStack
                                            })
                                        }
                                    >
                                        <AuthProvider>
                                            <PostHogIdentity />
                                            <ErrorBoundary
                                                FallbackComponent={
                                                    RootErrorFallback
                                                }
                                                onError={(error, info) =>
                                                    reportError(error, {
                                                        label: 'app-shell-root',
                                                        componentStack:
                                                            info?.componentStack
                                                    })
                                                }
                                            >
                                                <BrandingProvider>
                                                    <MapProvider>
                                                        <App />
                                                    </MapProvider>
                                                </BrandingProvider>
                                            </ErrorBoundary>
                                        </AuthProvider>
                                    </ErrorBoundary>
                                </BrowserRouter>
                            </div>
                            {/* </SettingsProvider> */}
                        </LocalizationProvider>
                    </StyledEngineProvider>
                </ReduxProvider>
                <ReactQueryDevtools
                    initialIsOpen={false}
                    position="bottom-right"
                />
            </QueryClientProvider>
        </HelmetProvider>
    </StrictMode>
)
